import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/ui/Button.jsx'
import Icon from '../../../components/ui/Icon.jsx'

/* Step 7 — completion. Calls onFinish (POST /onboarding/complete) + next-steps. */
export default function StepDone({ bindSubmit, onFinish }) {
  const { t } = useTranslation()
  useEffect(() => { bindSubmit(async () => true) }, [bindSubmit])

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ width: 60, height: 60, borderRadius: '50%', background: 'var(--color-success-bg)', color: 'var(--color-success)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}><Icon name="check" size={30} /></div>
      <h3 style={{ fontFamily: 'var(--font-title)', fontWeight: 800, fontSize: 22, color: 'var(--color-ink)', marginBottom: 8 }}>{t('setup.steps.done.title')}</h3>
      <p style={{ color: 'var(--color-text)', fontSize: 14.5, marginBottom: 24, maxWidth: 440, marginInline: 'auto' }}>{t('setup.steps.done.message')}</p>
      <Button variant="primary" icon="check" onClick={onFinish}>{t('setup.finish')}</Button>
    </div>
  )
}
